import { gsap } from 'gsap';

(function () {
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    /**
     * Stop all iframes or HTML5 <video>'s from playing
     */
    const stopVideos = function (item) {
        const videos = item.querySelectorAll('iframe, video');

        if (!videos.length) {
            return;
        }
        Array.prototype.forEach.call(videos, function (video) {
            if (video.tagName.toLowerCase() === 'video') {
                video.pause();
            } else {
                var src = video.src;
                video.src = src;
            }
        });
    };

    if (!accordionItems.length) {
        return;
    }

    accordionItems.forEach((accordionItem) => {
        const details = <HTMLDetailsElement>accordionItem;
        const clickTarget = <HTMLElement>accordionItem.querySelector('summary');
        const collapsibleElement = <HTMLElement>accordionItem.querySelector('.accordion-item__content');

        clickTarget.onclick = function (e) {
            e.preventDefault();

            if (details.open) {
                stopVideos(accordionItem);
                gsap.to(collapsibleElement, {
                    duration: 0.3,
                    height: 0,
                    ease: 'expo.inOut',
                    onComplete: () => {
                        details.open = false;
                    },
                });
            } else {
                details.open = true;
                gsap.set(collapsibleElement, { height: 'auto' });
                gsap.from(collapsibleElement, {
                    duration: 0.3,
                    height: 0,
                    ease: 'expo.inOut',
                    onComplete: () => (collapsibleElement.style.height = 'auto'),
                });
            }
        };
    });
})();
